export default "data:image/webp;base64,UklGRjoAAABXRUJQVlA4TC4AAAAvJwAGABfwGLX5U5C2AeNfSXc9zn9Ex4OZtm18lT+NjuoKIKL/E4AGLLuHaMAy"